import bus from "./bus";

export function selectImage() {
    return new Promise(resolve => {
        bus.emit("select-image");
        bus.on("select-image-result", resolve);
    });
}

export function selectHouse() {
    return new Promise(resolve => {
        bus.emit("select-house");
        bus.on("select-house-result", resolve);
    });
}

export function selectPurchaser() {
    return new Promise(resolve => {
        bus.emit("select-purchaser");
        bus.on("select-purchaser-result", resolve);
    });
}

export function selectUser() {
    return new Promise(resolve => {
        bus.emit("select-user");
        bus.on("select-user-result", resolve);
    });
}

export function selectStore() {
    return new Promise(resolve => {
        bus.emit("select-store");
        bus.on("select-store-result", resolve);
    });
}